import React from "react";
import EmojiObjectsTwoToneIcon from '@material-ui/icons/EmojiObjectsTwoTone';

function Heading(){
    var head = (<header><h1>
    <EmojiObjectsTwoToneIcon />
    Keeper</h1></header>);
    return head;
}

export default Heading;